import styled from 'styled-components';
import { ComboboxInputMixin } from '../../mixins/components/ComboboxInputMixin';
export var StyledComboboxInput = /*#__PURE__*/styled.div.withConfig({
  displayName: "StyledComboboxInput",
  componentId: "c11n-8-111-1__sc-78pewz-0"
})(["", ""], ComboboxInputMixin);